module.exports = __webpack_public_path__ + "static/media/marriage.35626a35.svg";